import Axios from 'axios';
import React from 'react';
import { toast } from 'react-toastify';

import Expired from 'Pages/Auth/Expired';

/**
 * @classdesc Http base class
 */
class Http {
  /**
   * @array[]
   */
  dontAlertOn = [
    '/login', '/register', '/forgot-password', '/reset-password', '/logout',
  ];

  /**
   * @type {boolean}
   */
  first = true;

  /**
   * @constructor
   */
  constructor() {
    const headers = {
        'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
    };

    this.client = Axios.create({
      baseURL: process.env.MIX_API_BASE,
      validateStatus: function (status) {
        return status >= 200 && status <= 399; // default
      },
      headers,
    });
  }

  /**
   * @method setToken
   * @param {string} token
   * @return {Promise<void>}
   */
  setToken = async (token) => {
    this.client.defaults.headers['Authorization'] = 'Bearer ' + token;
  };

  /**
   * @method post
   * @param {string} url
   * @param {object} data
   * @param {object} config
   * @return {Promise}
   */
  post = async (url, data, config = {}) => {
    return this.client
      .post(url, data, config)
      .catch(this.handleError);
  };

  /**
   * @method delete
   * @param {string} url
   * @param {object} data
   * @return {Promise}
   */
  delete = async (url, data) => {
    return this.client
      .delete(url, {
        data,
      })
      .catch(this.handleError);
  };

  /**
   * @method put
   * @param {string} url
   * @param {object} data
   * @return {Promise}
   */
  put = async (url, data) => {
    return this.client
      .put(url, data)
      .catch(this.handleError);
  };

  /**
   * @method patch
   * @param {string} url
   * @param {object} data
   * @return {Promise}
   */
  patch = async (url, data) => {
    return this.client
      .patch(url, data)
      .catch(this.handleError);
  };

  /**
   * @method get
   * @param {string} url
   * @param {object} data
   * @return {Promise}
   */
  get = async (url, data = {}) => {
    return this.client
      .get(url, {
        params: data,
      })
      .catch(this.handleError);
  };

  /**
   * @method handleError
   * @param {Event} e
   */
  handleError = e => {
    if (e.response && !this.first) {
      if ([401].indexOf(e.response.status) !== -1 && this.shouldAlert()) {
        toast(<Expired />);
      }
    }

    this.first = false;

    throw e;
  };

  /**
   * @method shouldAlert
   * @returns {boolean}
   */
  shouldAlert = () => {
    const matches = this.dontAlertOn.filter((url) => {
      return window.location.pathname.startsWith(url);
    });

    return matches.length === 0;
  };
}

export default new Http();
